<template>
  <modal partners @close="$emit('close')" class="">
    <div class="py-5 px-16 text-sm font-semibold text-main-text text-center m-6 mb-3 relative">
      <button class="absolute pin-t pin-r outline-none m-6 -mt-2 z-40" @click="$emit('close')">
        <img class="h-4" src="@/assets/SVG/cross-partners.svg" />
      </button>
      <p class="text-lg mt-4 ">Измените количество игроков</p>
      <plus-minus-counter class="mt-4" :max="event.max_team_players" v-model="form.player_count" :def="team.player_count" :min="min_player_count"></plus-minus-counter>
      <div class="flex flex-col content-start items-stretch pt-5">
        <button class="rounded-full outline-none text-white hover-up bg-brand-light py-3 font-semibold" @click="closeReg">
            Изменить
        </button>
      </div>
    </div>
  </modal>

</template>

<script>
import ModalMixin from '@/mixins/modals';
import Modal from '@/views/modals/base-modal';
import Form from 'form-backend-validation';
import client from '@/clients/player';
import PlusMinusCounter from '../components/plus-minus-counter.vue';
import { mapActions } from 'vuex';

export default {
  name: 'Participate',
  components: { Modal, PlusMinusCounter },
  props: ['thanks', 'participate', 'team', 'event', 'city_id'],
  mixins: [ModalMixin],

  data() {
    return {
      min_player_count: this.city_id === 6 ? 1 : 2,
      teamValue: 2,
      show: true,
      loaded: false,
      vale: this.thanks,
      form: new Form({
        player_count: 0,
      }, { http: client }),

    };
  },
  created() {
    this.loaded = true;
    this.form.player_count = this.team.player_count;
  },
  computed: {
    userData() {
      return this.$store.getters.userInfo;
    },

  },
  methods: {
    ...mapActions(['updateUserApplication']),
    declOfNum(number, titles) {
      const cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    },
    closeReg() {
      const temp_value = this.form.player_count;
      this.form.patch(`/applications/${this.team.id}/player-count/change`)
        .then((response) => {
          this.updateUserApplication({ id: this.team.id, player_count: temp_value });
          this.$emit('thanks');
          this.vale = !this.vale;
        });
    },

  },

};

</script>

<style scoped>


    input[type=range] {
        -webkit-appearance: none;
        margin: 18px 0;
        width: 100%;
    }

    input[type=range]:focus {
        outline: none;
    }

    input[type=range]::-webkit-slider-runnable-track {
        width: 100%;
        height: 2px;
        cursor: pointer;
        animate: 0.2s;
        background: #550045;
    }

    input[type=range]::-webkit-slider-thumb {
        box-shadow: 1px 1px 1px #bd006c, 0px 0px 1px #bd006c;
        border: 1px solid #bd006c;
        height: 20px;
        width: 20px;
        border-radius: 10px;
        background: #bd006c;
        cursor: pointer;
        -webkit-appearance: none;
        margin-top: -9px;
        margin-bottom: -9px;
    }

    input[type=range]:focus::-webkit-slider-runnable-track {
        background: #550045;
    }

    input[type=range]::-moz-range-track {
        width: 100%;
        height: 1.4px;
        cursor: pointer;
        animate: 0.2s;
        box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
        background: #550045;
        border-radius: 1.3px;
        border: 0.2px solid #550045;
    }

    input[type=range]::-moz-range-thumb {
        box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
        border: 1px solid #550045;
        height: 36px;
        width: 16px;
        border-radius: 3px;
        background: #550045;
        cursor: pointer;
    }

    input[type=range]::-ms-track {
        width: 100%;
        height: 1.4px;
        cursor: pointer;
        animate: 0.2s;
        background: transparent;
        border-color: transparent;
        border-width: 16px 0;
        color: transparent;
    }

    input[type=range]::-ms-fill-lower {
        background: #550045;
        border: 0.2px solid #550045;
        border-radius: 2.6px;
        box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
    }

    input[type=range]::-ms-fill-upper {
        background: #550045;
        border: 0.2px solid #550045;
        border-radius: 2.6px;
        box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
    }

    input[type=range]::-ms-thumb {
        box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
        border: 1px solid #550045;
        height: 20px;
        width: 20px;
        border-radius: 3px;
        background: #550045;
        cursor: pointer;
    }

    input[type=range]:focus::-ms-fill-lower {
        background: #550045;
    }

    input[type=range]:focus::-ms-fill-upper {
        background: #550045;
    }


</style>
